module.exports = function() {
  return new Worker(__webpack_public_path__ + "7ba6b0a2736028a60f1f.worker.js");
};